import { Card, Typography } from 'antd';
import { FC } from 'react';
import { Link, type To } from 'react-router-dom';
import styled from 'styled-components';
import { StyledTitle } from 'components/StyledTitle';

const { Paragraph } = Typography;

type CardProps = {
  title: string;
  description: string;
  to: To;
};

export interface IconCardProps extends CardProps {
  icon: string;
  height?: string;
  isExternal?: boolean;
  topRightText?: string;
  level?: 4 | 5;
}

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledHeaderText = styled.div`
  font-size: 12px;
  line-height: initial;
  color: rgba(140, 140, 140);
`;

const StyledLink = styled(Link)`
  color: initial;
`;

const Description = styled(Paragraph)`
  width: 100%;
  color: var(--neutral-8);
  margin-bottom: 0 !important;
`;

const StyledCard = styled(Card)<{ height?: string }>`
  height: ${(props) => (props.height ? props.height : '13.75rem')};
  max-width: 270px;
  border-radius: 0.5rem;

  > .ant-card-body {
    padding: 1rem 1.5rem;
  }
`;

const IconCardLink: FC<IconCardProps> = ({
  icon: Icon,
  to,
  title,
  description,
  height,
  isExternal = false,
  topRightText,
  level,
}) => {
  const IconCard = (): JSX.Element => {
    return (
      <StyledCard height={height}>
        <StyledHeader>
          <img src={Icon} alt={`card ${title} icon`} />
          <StyledHeaderText>{topRightText}</StyledHeaderText>
        </StyledHeader>
        <StyledTitle level={level ? level : 5} color="var(--neutral-9)">
          {title}
        </StyledTitle>
        <Description>{description}</Description>
      </StyledCard>
    );
  };

  return isExternal ? (
    <a href={to as string} target="_blank" rel="noreferrer">
      <IconCard />
    </a>
  ) : (
    <StyledLink to={to}>
      <IconCard />
    </StyledLink>
  );
};

export default IconCardLink;
